import { render, staticRenderFns } from "./b-menu-breadcrumb-item.vue?vue&type=template&id=1f545846&scoped=true&"
import script from "./b-menu-breadcrumb-item.vue?vue&type=script&lang=js&"
export * from "./b-menu-breadcrumb-item.vue?vue&type=script&lang=js&"
import style0 from "./b-menu-breadcrumb-item.vue?vue&type=style&index=0&id=1f545846&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f545846",
  null
  
)

export default component.exports